import * as React from "react";
const SvgFiRrStomach = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M15 3h-5C8.602 3 7.299 2.033 6.969.75A1.006 1.006 0 0 0 5.751.03a1 1 0 0 0-.72 1.219C5.509 3.104 7.101 4.525 9 4.9v9.098c0 2.176-3.59 3.173-3.717 3.304A5.01 5.01 0 0 0 2 22v1a1 1 0 1 0 2 0v-1c0-1.305.836-2.416 2-2.828q.26.161.511.322c2.012 1.274 3.911 2.479 8.487 2.505h.04c1.835 0 3.568-.72 4.886-2.03A6.97 6.97 0 0 0 21.999 15v-5c0-3.858-3.141-7-7-7zm0 2c2.757 0 5 2.243 5 5v1.313A6.3 6.3 0 0 0 18 11c-1.185 0-1.971.301-2.664.566-.608.232-1.134.434-1.949.434A5.4 5.4 0 0 1 11 11.425V5zm3.515 13.552a4.9 4.9 0 0 1-3.477 1.447h-.027c-3.58-.021-5.167-.79-6.832-1.819C9.497 17.45 11 16.145 11 14v-.41c.646.225 1.46.41 2.387.41 1.185 0 1.971-.302 2.664-.566C16.659 13.202 17.185 13 18 13c.986 0 1.65.29 2 .5V15a4.98 4.98 0 0 1-1.485 3.552"
    />
  </svg>
);
export default SvgFiRrStomach;
